/**
 * Names of all the workers
 */ export var Worker = /*#__PURE__*/ function(Worker) {
    Worker["BootObserver"] = "bootObserver";
    Worker["CacheDataFetch"] = "cacheDataFetch";
    Worker["CacheEviction"] = "cacheEviction";
    Worker["CacheUpdate"] = "cacheUpdate";
    Worker["Campaign"] = "campaign";
    Worker["CdsProvisioningStatus"] = "cdsProvisioningStatus";
    Worker["ChildViewInstantiation"] = "childViewInstantiation";
    Worker["DataFetch"] = "dataFetch";
    Worker["DataIntegrity"] = "dataIntegrity";
    Worker["DeferredBootOperations"] = "deferredBootOperations";
    Worker["DocumentTitle"] = "documentTitle";
    Worker["HistoryObserver"] = "historyObserver";
    Worker["Modal"] = "modal";
    Worker["Mru"] = "mru";
    Worker["Navigation"] = "navigation";
    Worker["NetworkConnectivity"] = "networkConnectivity";
    Worker["OperationTracking"] = "operationTracking";
    Worker["PageVisibilityObserver"] = "pageVisibilityObserver";
    Worker["PerformanceObserver"] = "performanceObserver";
    Worker["PlanLinkCleanup"] = "planLinkCleanup";
    Worker["PlanContextRefresh"] = "planContextRefresh";
    Worker["PlanConversionRedirectWorker"] = "planConversionRedirectWorker";
    Worker["PremiumPlanCreationStatus"] = "premiumPlanCreationStatus";
    Worker["ProjectTrialOperationTracker"] = "projectTrialOperationTracker";
    Worker["RecommendedPlansUpdate"] = "recommendedPlansUpdate";
    Worker["ServiceWorkerBootstrap"] = "serviceWorkerBootstrap";
    Worker["TeamsTab"] = "teamsTab";
    Worker["TrouterSubscriptionRefresh"] = "trouterSubscriptionRefresh";
    Worker["UndoRedo"] = "undoRedo";
    return Worker;
}({});
